import React from 'react';
import { Hero } from '../components/sections/Hero';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { Recognize } from '../components/sections/Recognize';
import { Volumes } from '../components/sections/Volumes';
import { Philosophy } from '../components/sections/Philosophy';
import { WhatYouGet } from '../components/sections/WhatYouGet';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { About } from '../components/sections/About';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { PurchasePopup } from '../components/PurchasePopup';
import { MetaPixel } from '../components/MetaPixel';
export function Landing() {
  return <div className="w-full bg-white" data-id="element-310" data-mp="2atkipzxufgy">
      <MetaPixel data-id="element-311" data-mp="27nun8jhj9k6" />
      <Hero data-id="element-312" data-mp="3tgl8biq8tg0l" />
      <main data-id="element-313" data-mp="3tftmv0qd0yo1">
        <BeforeAfter data-id="element-314" data-mp="3tfa3dfl2a27w" />
        <Recognize data-id="element-315" data-mp="3tes1a2bpwts2" />
        <Volumes data-id="element-316" data-mp="3tifqwqe1kw1i" />
        <Philosophy data-id="element-317" data-mp="3peq4o7kuaqjn" />
        <WhatYouGet data-id="element-318" data-mp="3pdybf3ept4wj" />
        <Bonuses data-id="element-319" data-mp="3pfj7ixgogvwi" />
        <Offer data-id="element-320" data-mp="3pezxs416ldtk" />
        <Guarantee data-id="element-321" data-mp="3pgkthwz8f2t0" />
        <Testimonials data-id="element-322" data-mp="3kfwuao0unfnp" />
        <About data-id="element-323" data-mp="3kgeufvqmue0w" />
        <FAQ data-id="element-324" data-mp="3kgyebhzufchk" />
        <FinalCTA data-id="element-325" data-mp="3khho2bfcauki" />
      </main>
      <Footer data-id="element-326" data-mp="l0i981d74znv" />
      <FloatingCTA triggerId="first-cta" data-id="element-327" data-mp="l11iktos6fqa" />
      <PurchasePopup data-id="element-328" data-mp="l008arfl9x9m" />
    </div>;
}